import { createContext, useContext } from "react";

interface FinancialAccountsConnectionContextValue {
    showAccountTypeWarning: boolean;
}

export const FinancialAccountsConnectionContext =
    createContext<FinancialAccountsConnectionContextValue>({
        showAccountTypeWarning: false,
    });

export function useFinancialAccountsConnectionContext() {
    const ctx = useContext(FinancialAccountsConnectionContext);

    if (!ctx) {
        throw new Error("Show only be used inside AccountsConnectionProvider ");
    }

    return ctx;
}
